<template>
  <div class="view home">
    <Header />
    <div class="items-wrap">
      <CardsList ref="cardsList" :items="cardItemsList" @scroll="onScroll"/>
    </div>
  </div>
</template>

<script>
  import { executeOnTV } from '../utils/utils';
  import cardsService, { CardColor, CardType, MediaType } from '@/services/cards.service';
  import Header from '@/components/Header.vue';
  import Banner from '@/components/Banner.vue';
  import CardsList from '@/components/CardsList.vue';
  import userUtil from '@/utils/user.util';

  export default {
    components: { Header, CardsList, Banner },
    data() {
      return {
        CARDS_LIMIT: 20,
        cardItems: [],
        repeatableCardItems: [],
        repeated: 0,
        offset: 0,
        lastGeneratedId: 10101010,
        lastColorIndex: 0,
        loading: false,
        noMoreCards: false,
        offsetColor: 18,
        imageDeviceType: userUtil.imageDeviceType(),
      };
    },
    computed: {
      settings() {
        return this.$store.state.settings;
      },
      getContentType() {
        return this.$store.getters['settings/getContentType'];
      },
      cardItemsList: {
        get() {
          return this.cardItems;
        },
      },
    },
    methods: {
      setDisplayLoader(val) {
        this.$store.dispatch('settings/setDisplayLoader', val);
      },
      setLoadingCards(val) {
        this.$store.dispatch('settings/setLoadingCards', val);
      },
      setBannerState(val) {
        this.$store.dispatch('settings/setBannerState', val);
      },
      setHeaderBannerState(val) {
        this.$store.dispatch('settings/setHeaderBannerState', val);
      },
      checkForBanner() {
        const params = new URLSearchParams(window.location.search);

        if (params.has('showBanner')) {
          this.setHeaderBannerState(true);
          this.setBannerState(true);
        }
      },
      async onScroll(scrollInfo) {
        if (this.isAtScrollEnd(scrollInfo) && this.loading === false && this.noMoreCards === false) {
          this.loading = true;
          await this.loadMore();
          this.loading = false;
        }

        if (this.isAtScrollVeryEnd(scrollInfo) && this.loading === false && this.noMoreCards) {
          this.loading = true;
          await this.repeatItems();
          this.loading = false;
        }
      },
      async cardsOnTv() {
        this.setLoadingCards(true);
        const cards = await this.getCardItems(this.offset += this.CARDS_LIMIT);
        if (cards.length === 0) {
          this.noMoreCards = true;
        }
        cards.forEach((card) => {
          if (card.mediaType !== MediaType.MixedGames) {
            if (card.type !== 'sound') {
              card.color = this.generateColor();
            }
            this.cardItems.push(card);
          }
        });
      },
      async cardsNotOnTv() {
        const cards = await this.getCardItems(this.offset += this.CARDS_LIMIT);
        if (cards.length === 0) {
          this.noMoreCards = true;
        }
        cards.forEach((card) => {
          this.cardItems.push(card);
        });
        // Generate color for all cards
        this.cardItems.map((card, index) => {
          if (index > this.offsetColor) {
            if (card.type !== 'sound') {
              card.color = this.generateColor();
            }
          }
          if (card.color === null ) {
            card.color = this.generateColor();
          }
        });
        this.offsetColor += (this.cardItems.length - this.offsetColor);
      },
      async loadMore() {
        executeOnTV(this.cardsOnTv, this.cardsNotOnTv);
        this.triggerScrollRefresh();
      },
      async getCardItems(offset = this.offset) {
        const cardsApiResponse = await cardsService.getCardsList(this.getContentType, offset, this.CARDS_LIMIT);
        var cardList = cardsApiResponse.filter((card) => card.type === CardType.Folder || card.type === CardType.Sound)
        .map((card, index) => {
          const identifier = parseInt(card.identifier, 10) || this.generateItemId();
          const uniqueId = Math.random().toString(16).slice(2);
          // Generate first game color card
          try {
            if (VK_DOWN) {
              if (card.type === CardType.Folder /*&& card.mediaType === MediaType.Video*/) {
                if (card.mediaType === MediaType.Video) {
                  return {
                    identifier,
                    key: identifier,
                    type: card.type,
                    color: offset === 0 ? this.generateColor() : null,
                    mediaType: card.mediaType,
                    imageUrl: card.identifier ? `${process.env.VUE_APP_CLOUDFRONT_URL}/${this.imageDeviceType}/${identifier}.png` : null,
                  };
                } else {
                  return {
                    identifier,
                    key: identifier,
                    type: card.type,
                    color: 'orange',
                    mediaType: card.mediaType,
                    imageUrl: card.identifier ? `${process.env.VUE_APP_CLOUDFRONT_URL}/${this.imageDeviceType}/${identifier}.png` : null,
                  };
                }
              } else /*if (card.type === CardType.Sound)*/ {
                return {
                  identifier,
                  key: identifier,
                  type: card.type,
                  sound: card.sound,
                };
              }
            }
          } catch (error) {
            if (card.mediaType === MediaType.MixedGames) {
              return {
                identifier,
                key: uniqueId,
                type: card.type,
                mediaType: card.mediaType,
                imageUrl: `https://d3aod987c9rl70.cloudfront.net/webApp/games-new/images/coloring.png`,
              };
            }
            // Generate cards other than game color cards
            if (card.type === CardType.Folder) {
              return {
                identifier,
                key: identifier,
                type: card.type,
                color: offset === 0 ? this.generateColor() : null,
                mediaType: card.mediaType,
                imageUrl: card.identifier ? `${process.env.VUE_APP_CLOUDFRONT_URL}/${this.imageDeviceType}/${identifier}.png` : null,
              };
            } else {
              return {
                identifier,
                key: identifier,
                type: card.type,
                sound: card.sound,
              };
            }
          }
        });
        // try {
        //   if (VK_DOWN) {
        //     // Empty block to detect vewd TV
        //   }
        // } catch (error) {
        // }
        this.setDisplayLoader(false);
        this.setLoadingCards(false);
        return cardList;
      },
      async repeatItems() {
        if (this.repeatableCardItems.length === 0) {
          this.repeatableCardItems = Array.from(this.cardItems);
        }
        this.repeated++;

        this.repeatableCardItems.forEach((card) => {
          const newCard = {
            ...card,
            key: this.repeated * 100000 + card.key,
            color: this.generateColor(),
          };
          this.cardItems.push(newCard);
        });

        this.triggerScrollRefresh();
      },
      triggerScrollRefresh() {
        this.$refs.cardsList.triggerScrollRefresh();
      },
      generateItemId() {
        return this.lastGeneratedId++;
      },
      generateColor() {
        const colors = Object.values(CardColor);
        const color = colors[this.lastColorIndex++];
        if (this.lastColorIndex >= colors.length) {
          this.lastColorIndex = 0;
        }

        return color;
      },
      isAtScrollEnd(scrollInfo) {
        return scrollInfo.vertical.process > 0.9 || scrollInfo.horizontal.process > 0.9;
      },
      isAtScrollVeryEnd(scrollInfo) {
        return scrollInfo.vertical.process === 1 || scrollInfo.horizontal.process === 1;
      },
    },
    async created() {
      this.checkForBanner();
      this.setDisplayLoader(true);
      this.cardItems = await this.getCardItems();
      executeOnTV(this.onTv);
      this.triggerScrollRefresh();
    },
  };

</script>

<style lang="scss" scoped>
  @import '../assets/styles/breakpoints.scss';

  .items-wrap {
    position: relative;

    @media (orientation: portrait) {
      height: 100%;

      .top-bar--has-height + & {
        height: calc(100% - 74px);
      }
    }

    @media (orientation: landscape) {
      height: 100%;
    }
  }
</style>